module.exports = __webpack_public_path__ + "img/2026-08-25 Frauenrunde Huemer Riedl Kaiser Polt.c760cac7.jpg";